import React from 'react';

import styles from './Regions.module.scss';

const Regions = (props) => (
  <div className={styles.Regions}>
    <div className={styles.Regions__Wrapper}>
      <h2>The regions</h2>
      <div>
        {props.cards.map((region, i) =>
          <div className={styles.Region} key={i}>
            <h3>{region.title}</h3>
            <p className={styles.Region__Description}>{region.text.text}</p>
            <div className={`${styles.Region__Image} para-cont`}>
              <img className={`${styles.Region__Image__Image} para-item`} data-speed='4' src={region.featuredImage.file.url} />
            </div>
            <div className={styles.Region__Details}>
              <div className={styles.Region__Stats}>
                {region.regionDetails.map((detail, iterator) =>
                  <div key={iterator}>
                    <p>{detail.title}</p>
                    <p>{detail.text.text}</p>
                  </div>
                )}
              </div>
              <div  className={styles.Region__Map}>
                <img src={region.locationImage.file.url} alt={region.locationImage.title} />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  </div>
)

export default Regions;



// WEBPACK FOOTER //
// ./src/components/Destination/Regions/index.js